module.exports = __webpack_public_path__ + "static/media/Stomach.002f47f8.ogg";